export default [
  {
    path: '/invite',
    name: 'Invite',
    component: () => import('@/views/user/index.vue'),
    meta: {
      auth: true, // 需要登录
      title: '邀请',
      keepAlive: false,
      headerTheme: 'dark'
    }
  }
]
